(function ($) {
  
  Drupal.behaviors.main = {
    attach: function (context, settings) {

      // Header.
      var $header = $('.header');
      var headerHeight = $header.outerHeight();
      var pageWrapperOffset = $('.dialog-off-canvas-main-canvas').offset().top;

      $('.layout-container').css({"padding-top": headerHeight});
      $header.css('top', pageWrapperOffset);


      // Menu.
      var $hamburger = $("header").find(".hamburger");
      if ($hamburger.length > 0) {
        $hamburger.off('click').on("click", function (e) {
          $(this).toggleClass("menu-is-open");
          $(".region-header").toggleClass("menu-is-open");
          $("body").toggleClass("menu-is-open");
        });
      }
      
      $('.view-sidebar').find('input').off().on('change', function (e) {
        let $filters = $('.view-filters');
        let $submit = $filters.find('input[type=submit]');
        let $input = $filters.find('#' + $(this).attr('id'));
        
        if ($input.prop('checked') === true) {
          $input.prop("checked", false);
        }
        else {
          $input.prop("checked", true);
        }
        
        $submit.click();
      });
      
      // Swiper.
      if ($(".paragraph--type-slides").length > 0) {
        const swiper = new Swiper('.paragraph--type-slides', {
          loop: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
      
      
    }
  }
  
})(jQuery);
